import APIClient from '@/shared/http/clients/apiupload.js'

const resourceName = 'followup'
const APICore = process.env.APIBaseURLCore

const GetAll = (document, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&sort=id,desc&`, data, config)
const GetAllPaging = (document, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${id}/`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}/`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)
const FileShare = (id, fileuuid, config = {}) => APIClient.post(`${APICore}/${resourceName}/${id}/files/${fileuuid}/share`, config)
const FileShareDespesas = (id, fileuuid, config = {}) => APIClient.post(`${APICore}/${resourceName}/${id}/files/${fileuuid}/share/despesas`, config)
const GetAllByCardId = (cardId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?cardId=${cardId}&size=500`, config)
const CreateWithMnemonic = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/mnemonic`, data, config)
const GetAllMinhasVisitasPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/minhas-visitas?page=${index}&size=${limit}`, config)

const FollowupRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  FileShare,
  FileShareDespesas,
  GetAllByCardId,
  CreateWithMnemonic,
  GetAllMinhasVisitasPaging
}

export default FollowupRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/associate/followup.js